import { GET_MISMATCH_REQUESTS } from '../../endpoints';
import makeAuthenticatedRequest from '../base-api';

const getMismatchRequestsQueryKey = (
  agentId?: string,
  account?: string,
  date?: string
) => ['mismatch-requests', agentId, account, date].filter(Boolean);

interface IRaiseMismatch {
  _id: string;
  logId: string;
  shiftId?: string;
  comment?: string;
  files: string[];
  startTime: string;
  stopTime: string;
  kimId: string;
  account: string;
  status: 'pending' | 'resolved' | 'rejected';
  category?: string;
  createdAt: string;
  updatedAt: string;
}

const getMismatchRequests = async (
  agentId: string,
  account: string,
  date: string
): Promise<{
  success: boolean;
  data?: IRaiseMismatch[];
  message?: string;
}> => {
  try {
    const response = await makeAuthenticatedRequest(
      GET_MISMATCH_REQUESTS(agentId, account, date)
    );

    const result = await response.json();

    if (!result.success) {
      throw new Error(result.message);
    }

    return result;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export {
  getMismatchRequests,
  type IRaiseMismatch,
  getMismatchRequestsQueryKey,
};
